// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"f0ada666","186":"0e82f2bb","223":"0c57dafa","225":"6f31b0fa","272":"b1eb83bc","372":"40868419","377":"42de1614","573":"6791c35b","665":"35fef61a","738":"15fbac76","841":"3df8c8d0","856":"381c4b19"}[chunkId] + ".chunk.js";
};